<template>
  <section class="hero-home">
    <div class="hero-home__inner">

      <div class="hero-home__content">
        <span class="hero-home__sub">{{ blockData.line_1 }}</span>
        <h1 class="hero-home__title">{{ blockData.line_2 }}</h1>
        <h2 class="hero-home__subtitle">{{ blockData.line_3 }}</h2>
        <p class="hero-home__desc" v-if="blockData.desc">{{ blockData.desc }}</p>
      </div>

      <div class="hero-home__grid">
        <a
          v-for="(card, index) in blockData.cards"
          :key="index"
          :href="card.url"
          class="hero-home__card"
        >
          <h3>{{ card.title }}</h3>
          <p>{{ card.text }}</p>
        </a>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    blockData: {
      type: Object,
      required: true,
      default: () => ({
        line_1: '',
        line_2: '',
        line_3: '',
        desc: '',
        cards: []
      })
    }
  }
}
</script>
